import { MB_SITE_CONTEXT_FEATURE } from './state'
import { NgModule } from '@angular/core'
import { StoreModule } from '@ngrx/store'
import { reducerProvider, reducerToken } from './reducers'

@NgModule({
  imports: [
    StoreModule.forFeature(MB_SITE_CONTEXT_FEATURE, reducerToken),
  ],
  providers: [
    reducerProvider,
  ],
})
export class MbSiteContextStoreModule {
}
